<script>
	// Custom line mark for the Legends of Tasmania experience grid. Drawn to the
	// same geometry as the lucide set used elsewhere (24px box, 1.5 stroke,
	// round caps) so it sits naturally beside them.
	let { class: className = '' } = $props();
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 24 24"
	fill="none"
	stroke="currentColor"
	stroke-width="1.5"
	stroke-linecap="round"
	stroke-linejoin="round"
	class={className}
	aria-hidden="true"
>
	<path d="M3.5 10.5 12 4.5l8.5 6" />
	<path d="M5.6 9.9V20M18.4 9.9V20" />
	<path d="M16 6.4V4.2h2v3.7" />
	<path d="M10.4 20v-4.6h3.2V20" />
	<path d="M7.7 12.4h2.2v2.2H7.7zM14.1 12.4h2.2v2.2h-2.2z" />
	<path d="M4 20h16" />
</svg>
